// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdmitAllButton__link-d1e2ff {
  margin-inline-start: auto;
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
  color: var(--addition-50);
  cursor: pointer;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RightPanel/AdmitAllButton/AdmitAllButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,4BAAA;EACA,8CAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;AACF","sourcesContent":[".link {\n  margin-inline-start: auto;\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  color: var(--addition-50);\n  cursor: pointer;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `AdmitAllButton__link-d1e2ff`
};
module.exports = ___CSS_LOADER_EXPORT___;
